import React, { useEffect, useState } from "react";

const TypingText = () => {
  const texts = [
    "Hi :)",
    "Trade With Algo Controller :)",
    "Amazing Breakeven & Trailing Feature :)",
    "Unlimited Trade :)",
    "Boost Your Trading With One-Click Precision :)",
    "Login Now and Enjoy Free Features :)",
    "AlgoController.com :)"
  ];

  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let timeoutId;
    let isCancelled = false; // ✅ fresh flag for each mount

    async function typeText(text, elementIds) {
      for (let i = 0; i < text.length; i++) {
        if (isCancelled) return;
        for (let id of elementIds) {
          const el = document.getElementById(id);
          if (el) el.textContent += text.charAt(i);
        }
        await new Promise((res) => setTimeout(res, 50));
      }
    }

    async function typeWriter() {
      for (let j = 0; j < texts.length; j++) {
        if (isCancelled) return;
        for (let id of ["ft", "ftt"]) {
          const el = document.getElementById(id);
          if (el) el.textContent = "";
        }

        await typeText(texts[j], ["ft", "ftt"]);

        if (j < texts.length - 1) {
          await new Promise((res) => setTimeout(res, 2500));
        }
      }
    }

    typeWriter();

    return () => {
      isCancelled = true; // ✅ stop async loop when unmounting/navigating
      clearTimeout(timeoutId);
    };
  }, [index]);

  return <p style={{ fontSize: "16px" }}>{displayedText}</p>;
};

export default TypingText;
